import { useEffect, useState } from "react";
import Container from "@/components/Container";
import { api } from "@/lib/api";

export default function Reports() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/reports/overview").then(r => setD(r.data)).catch(() => {}); }, []);
  if (!d) return <Container className="py-12 text-ivory/40">Loading…</Container>;
  return (
    <Container className="py-8 md:py-12">
      <p className="overline">Library</p>
      <h1 className="mt-2 text-4xl md:text-5xl font-serif text-ivory">Reports</h1>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-6">
        <Block title="Properties by Source" rows={d.by_source} renderRow={(r) => <Row k={r._id || "—"} v={r.count} />} />
        <Block title="Properties by City" rows={d.by_city} renderRow={(r) => <Row k={r._id || "—"} v={r.count} />} />
        <Block title="Leads by Type" rows={d.leads_by_type} renderRow={(r) => <Row k={r._id || "—"} v={r.count} />} />
        <Block title="Deal Pipeline Value" rows={d.pipeline} renderRow={(r) => <Row k={r._id} v={`${r.count} · £${(r.value||0).toLocaleString()}`} />} />
      </div>
    </Container>
  );
}

function Block({ title, rows, renderRow }) {
  return (
    <div className="luxury-card p-6">
      <p className="overline">{title}</p>
      <div className="mt-4 divide-y divide-charcoal-600/60">
        {!rows || rows.length === 0 ? <p className="text-ivory/40 text-sm py-3">No data.</p> : rows.map((r, i) => <div key={i}>{renderRow(r)}</div>)}
      </div>
    </div>
  );
}
function Row({ k, v }) {
  return <div className="flex justify-between py-2 text-sm"><span className="text-ivory/60 uppercase tracking-[0.15em] text-[0.7rem]">{k}</span><span className="text-ivory">{v}</span></div>;
}
